var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48148 1.11111C1.72115 1.11111 1.11111 1.74431 1.11111 2.48148V17.5185C1.11111 18.2789 1.74431 18.8889 2.48148 18.8889H17.5185C18.2857 18.8889 18.8948 18.2835 18.9259 17.5448V2.48148C18.9259 1.72115 18.2927 1.11111 17.5556 1.11111H2.48148ZM0 2.48148C0 1.14458 1.09367 0 2.48148 0H17.5556C18.8925 0 20.037 1.09367 20.037 2.48148V17.5655L20.0367 17.5754C19.9891 18.9067 18.8963 20 17.5185 20H2.48148C1.14458 20 0 18.9063 0 17.5185V2.48148Z",
    fill: "#524F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6291 5.18533H0.740234V4.07422H19.6291V5.18533Z",
    fill: "#524F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.85135H3V8.74023H17V9.85135Z",
    fill: "#524F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.75C4.5 8.33579 4.16421 8 3.75 8V8C3.33579 8 3 8.33579 3 8.75V9.84259C3 10.2568 3.33579 10.5926 3.75 10.5926V10.5926C4.16421 10.5926 4.5 10.2568 4.5 9.84259V8.75Z",
    fill: "#524F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14.8513H3V13.7402H17V14.8513Z",
    fill: "#524F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.75C4.5 13.3358 4.16421 13 3.75 13V13C3.33579 13 3 13.3358 3 13.75V14.8426C3 15.2568 3.33579 15.5926 3.75 15.5926V15.5926C4.16421 15.5926 4.5 15.2568 4.5 14.8426V13.75Z",
    fill: "#524F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.fb5cb7d9e582234d42a6669a804cff57.svg";
export { ForwardRef as ReactComponent };